<template>
  <section class="statement-section" :class="`theme-${track}`">
    <div class="layout-content">
      <div class="statement-body">
        <header class="statement-heading">
          <h2>{{ isEnglish ? 'Competition Statement' : '赛事声明' }}</h2>
        </header>
        <div class="statement-list">
          <article v-for="(item,index) in statements" :key="item">
            <span>{{ String(index + 1).padStart(2,'0') }}</span><p>{{ item }}</p>
          </article>
        </div>
      </div>
      <footer>
        <strong>{{ isEnglish ? '2026 Shenzhen International FinTech Competition — WeBank FinTech College Students Challenge' : '2026深圳国际金融科技大赛——微众银行金融科技大学生挑战赛' }}</strong>
        <span>{{ isEnglish ? 'August 2026' : '2026 年 8 月' }}</span>
      </footer>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props:{ track:{type:String,default:'domestic'}, language:{type:String,default:'zh'} },
  computed:{
    ...mapState(['isEnLang']),
    isEnglish(){ return this.isEnLang || (this.track === 'international' && this.language === 'en') },
    statements(){
      if(this.isEnglish) return [
        'Participants must read and comply with the official competition rules, complete entries independently, and ensure that all submitted information and materials are truthful and lawful.',
        'The Organising Committee may adjust the schedule, format, judging or defence arrangements according to actual circumstances and will notify teams through the official website, email or other official channels.',
        'Entry intellectual property remains with participants. Use of entries and team information by the organiser is limited to the non-commercial competition publicity purposes described in these rules.',
        this.track === 'international' ? 'The International Track is governed by the laws of the People’s Republic of China. The Chinese and English notices are published together; in case of discrepancy, the Chinese version prevails.' : 'The Organising Committee reserves the final right of interpretation of these rules.'
      ]
      return [
        '参赛者报名时应阅读并遵守大赛官网公布的参赛规则，独立完成作品，并确保所提交的信息及材料真实、合法、有效。',
        '组委会可根据实际情况调整赛程、比赛形式、评审或答辩安排，并通过官网、邮件或其他官方渠道提前通知参赛队伍。',
        '参赛作品知识产权归参赛选手所有；主办方对作品及队伍信息的使用，仅限本规则约定的赛事非商业性宣传用途。',
        this.track === 'international' ? '国际赛道适用中华人民共和国法律；中英文通知如存在歧义，以中文版为准。本规则最终解释权归大赛组委会所有。' : '本规则最终解释权归“深圳国际金融科技大赛”组委会所有。'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.statement-section{--accent:#dce8f7;padding:64px 0 66px;background:#1e3a5a;color:#fff}.theme-international{--accent:#d5eef2;background:#183f51}.statement-body{display:grid;grid-template-columns:220px minmax(0,1fr);gap:76px}.statement-heading h2{font-size:32px;font-weight:700;letter-spacing:.04em;line-height:1.25}.statement-list{display:flex;flex-direction:column;gap:24px;padding-top:4px}.statement-list article{display:grid;grid-template-columns:40px minmax(0,1fr);gap:16px}.statement-list span{color:var(--accent);font-family:DIN-BlackItalic,DIN;font-size:15px;font-style:italic;font-weight:700;line-height:1.9}.statement-list p{color:rgba(255,255,255,.9);font-size:13px;font-weight:500;line-height:1.9}.statement-section footer{display:flex;align-items:flex-end;flex-direction:column;gap:12px;margin-top:30px;color:rgba(255,255,255,.78);font-size:12px;text-align:right}.statement-section footer strong{color:#fff;font-size:13px;font-weight:600}.statement-section footer span{font-weight:600}
@include mobile{.statement-section{padding:46px 0 48px}.statement-body{grid-template-columns:1fr;gap:30px}.statement-heading h2{font-size:27px}.statement-list{gap:22px}.statement-list article{grid-template-columns:34px minmax(0,1fr);gap:10px}.statement-list p{font-size:12px;line-height:1.85}.statement-section footer{align-items:flex-start;margin-top:34px;text-align:left}.statement-section footer strong{line-height:1.7}}
</style>
